export default {
    id: "clues",
    route: {
        name: "ghosts-clues"
    }
}